import ModelState from './_util/model';

import APIRequestState from './_util/api-request';

class verticalsConfigState extends APIRequestState {
  get url() { return '/verticals/config'; }
  get method() { return 'GET'; }
  get singular() { return 'verticalConfig'; }
  get plural() { return 'verticalConfigs'; }
}

export default verticalsConfigState;



// WEBPACK FOOTER //
// ./spa/state/verticals-config.jsx